import React from "react";
import { handleOutsideClick } from "../../Helpers/HandleOutsideClick";

const ColumnFilterModal = ({
  show,
  onHide,
  title,
  items = [],
  filteredItems = [],
  setFilteredItems,
  selectedItems = [],
  setSelectedItems,
  searchText,
  setSearchText,
}) => {
  if (!show) return null;

  // Make sure selectedItems is always array
  const safeSelected = Array.isArray(selectedItems) ? selectedItems : [];

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      onClick={(e) => handleOutsideClick(e, onHide)}
    >
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black bg-opacity-40"
        onClick={onHide}
      ></div>

      {/* Modal */}
      <div className="relative bg-white w-[90%] sm:w-full sm:max-w-md rounded-xl shadow-xl p-4 sm:p-6 z-10 animate-fadeIn">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold">Filter by {title}</h3>
          <button
            onClick={onHide}
            className="text-gray-500 hover:text-black text-xl"
          >
            ✕
          </button>
        </div>

        {/* Search */}
        <input
          type="text"
          placeholder={`Search ${title}`}
          value={searchText}
          onChange={(e) => {
            const value = e.target.value;
            setSearchText(value);

            if (typeof setFilteredItems === "function") {
              setFilteredItems(
                items.filter((item) =>
                  item?.toString().toLowerCase().includes(value.toLowerCase()),
                ),
              );
            }
          }}
          className="w-full border border-gray-300 rounded-md px-3 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-primary"
        />

        {/* Select All */}
        <div className="flex items-center mb-3">
          <input
            type="checkbox"
            checked={
              safeSelected.length > 0 && safeSelected.length === items.length
            }
            onChange={(e) => setSelectedItems(e.target.checked ? items : [])}
            className="mr-2"
          />
          <label className="font-medium">Select All</label>
        </div>

        {/* Items List */}
        <div className="max-h-60 overflow-y-auto space-y-2">
          {filteredItems.map((item, idx) => (
            <div key={idx} className="flex items-center">
              <input
                type="checkbox"
                checked={safeSelected.includes(item)}
                onChange={() => {
                  if (safeSelected.includes(item)) {
                    setSelectedItems(safeSelected.filter((t) => t !== item));
                  } else {
                    setSelectedItems([...safeSelected, item]);
                  }
                }}
                className="mr-2"
              />
              <label className="text-sm">{item}</label>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onHide}
            className="px-4 py-2 rounded-md border border-gray-300 hover:bg-gray-100 transition"
          >
            Cancel
          </button>
          <button
            onClick={onHide}
            className="px-4 py-2 rounded-md bg-primary text-white hover:opacity-90 transition"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default ColumnFilterModal;
